import { createMuiTheme } from '@material-ui/core/styles'

import generateOverrides from '~/theme/overrides'

import palette from './palette'
import typography from './typography'

export const theme = createMuiTheme({
  direction: 'rtl',
  spacing: 10,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 894,
      lg: 1280,
      xl: 1440
    }
  },
  palette,
  typography,
  overrides: generateOverrides(palette)
})

export default theme
